import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';


const fieldId = 'op-cat-three';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPDOWN);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const initialValues = null;

const vFParams = {
  fieldTitle: 'Operational Categorisation Tier 3',
  placeholder: 'Please select',
};

const operationalCategorisationThree = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_DROPDOWN,
};

export { operationalCategorisationThree };
